<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Blumen"
      question2="bunte Wiesen"
      question3="Mitbringsel"
      claim="Prima! Dann bringe doch zur nächsten Feier mal etwas Originelleres als eine Flasche Wein mit!"
      solution="Wer zu Besuch kommt, möchte gerne etwas in den Händen halten. Meistens fällt die Wahl dann auf eine Flasche Wein oder einen Strauß Blumen. Wie wäre es, wenn du stattdessen mal einen ganzen Blühstreifen – oder wenigstens einen Teil davon verschenkst – als Patenschaft für eine ganze Blühsaison? Das ist nachhaltig und originell."
    />
    <textblock
      headline="Blumen als Mitbringsel – nur eben nachhaltig und originell"
      column1="Klar, es ist wirklich nicht immer leicht, das passende Gastgeschenk zu finden. Mal kennt man den Gastgeber gar nicht allzu gut, dann wieder hat man das Gefühl, derjenige hätte schon alles. Die Schriftstellerin Thyde Monnier hat einmal gesagt: „Ein Gastgeschenk ist genau so viel wert wie die Liebe, mit der es ausgesucht worden ist.“ Wir finden, dass in unserer Blühpatenschaft verdammt viel Liebe steckt. Schließlich rettest du damit nicht nur die Natur, sondern bereitest dem Gastgeber auch noch eine riesige Freude."
      column2="Und selbst, wenn du ein „Last-Minute-Geschenk“ suchst, bist du bei der Wilden Pracht genau richtig. Du brauchst einfach nur unten in drei einfachen Schritten unser Formular ausfüllen und dabei auswählen, für wie viele Quadratmeter du eine Patenschaft verschenken möchtest. Anschließend lädst du dir deine Blühkarte herunter. Auf vielfachen Wunsch versenden wir sie außerdem per Post an dich als richtige Karte, die du dem Gastgeber überreichen kannst. Und dank unserer Bienenpost, für die ihr euch beide anmelden könnt, bleibt ihr auch immer auf dem Laufenden, wie die Wilde Pracht wächst und gedeiht."
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und beeindrucke den Gastgeber mit deiner Kreativität."
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Feier",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform,
  },
  metaInfo: {
    title: "Magst du kleine Aufmerksamkeiten? | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Dann überrasche doch mal mit einer Blühpatenschaft, wenn du das nächste Mal auf einer Feier eingeladen bist!",
      },
      {
        itemprop: "name",
        content: "Magst du kleine Aufmerksamkeiten? | Wilde Pracht",
      },
      {
        property: "og:title",
        content: "Magst du kleine Aufmerksamkeiten? | Wilde Pracht",
      },
      {
        itemprop: "description",
        content:
          "Dann überrasche doch mal mit einer Blühpatenschaft, wenn du das nächste Mal auf einer Feier eingeladen bist!",
      },
      {
        property: "og:description",
        content:
          "Dann überrasche doch mal mit einer Blühpatenschaft, wenn du das nächste Mal auf einer Feier eingeladen bist!",
      },
    ],
  },
};
</script>

<style lang="scss"></style>
